/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminTeamMember
 */
export interface InputAdminTeamMember {
    /**
     * CrewRole прав поки не ріже — будь-який член екіпажу подає заявку й веде політ.
     * Потрібна, щоб підставляти пілота за замовчуванням у форму вильоту.
     * @type {string}
     * @memberof InputAdminTeamMember
     */
    crewRole: InputAdminTeamMemberCrewRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof InputAdminTeamMember
     */
    userId: number;
}


/**
 * @export
 */
export const InputAdminTeamMemberCrewRoleEnum = {
    Commander: 'commander',
    Pilot: 'pilot',
    Operator: 'operator',
    Member: 'member'
} as const;
export type InputAdminTeamMemberCrewRoleEnum = typeof InputAdminTeamMemberCrewRoleEnum[keyof typeof InputAdminTeamMemberCrewRoleEnum];


/**
 * Check if a given object implements the InputAdminTeamMember interface.
 */
export function instanceOfInputAdminTeamMember(value: object): boolean {
    if (!('crewRole' in value)) return false;
    if (!('userId' in value)) return false;
    return true;
}

export function InputAdminTeamMemberFromJSON(json: any): InputAdminTeamMember {
    return InputAdminTeamMemberFromJSONTyped(json, false);
}

export function InputAdminTeamMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminTeamMember {
    if (json == null) {
        return json;
    }
    return {
        
        'crewRole': json['crewRole'],
        'userId': json['userId'],
    };
}

export function InputAdminTeamMemberToJSON(value?: InputAdminTeamMember | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'crewRole': value['crewRole'],
        'userId': value['userId'],
    };
}

